import React from 'react';
import _ from 'lodash';
import AppleIcon from '@mui/icons-material/Apple';
import useAppInfo from '../../../hooks/appInfo.hook';
import DashboardLayout from "../../../layouts/Dashboard";
import FirstPublish from './FirstPublish/Index';
import UpdatePublish from './UpdatePublish';

export default function PublishIOS() {
    const { appInfo } = useAppInfo();

    return (
        <DashboardLayout
            Icon={AppleIcon}
            title="Aplicativo iOS"
            subtitle="Envie a versão iOS do seu aplicativo para a App Store"
        >
            {appInfo.iOSDownloadUrl
              ? <UpdatePublish />
              : <FirstPublish />
            }
        </DashboardLayout >
    )
}